<template>
  <div class="container" >
    <Modal @closeDialog="visible = false" :visible="visible" :errorMessage="resultMessage"></Modal>
    <div v-if="loading" class="fa-3x text-center">
      <i class="fas fa-spinner fa-spin"></i>
    </div>
    <div>
      <h2>Simplify District Boundaries</h2>
      <form>
        <div class="form-group">
          <label for="districtType">Select a district type to simplify</label>
          <select id="districtType" v-model="districtType" class="form-control" required>
            <option disabled value=""></option>
            <option>Congress</option>
            <option>State Legislative (Upper)</option>
            <option>State Legislative (Lower)</option>
            <option>School District</option>
          </select>
        </div>
        <div class="form-group">
          <label for="districtState">Enter a district state</label>
          <input id="districtState" v-model="districtState" type="text" class="form-control" required>
        </div>
        <div class="form-group">
          <label for="coveredRadio">Covered</label>
          <small class="helper-text">Null option will include both covered and non-covered districts</small>
          <div id="coveredRadio">
            <div class="checkbox">
              <label for="coveredTrue" class="form-check-label">True</label>
              <input id="coveredTrue" v-model="covered" type="radio" value="True" class="form-check-input" required>
            </div>
            <div class="checkbox">
              <label for="coveredTrue" class="form-check-label">False</label>
              <input id="coveredFalse" v-model="covered" type="radio" value="False" class="form-check-input" required>
            </div>
            <div class="checkbox">
              <label for="coveredTrue" class="form-check-label">Null</label>
              <input id="coveredNull" v-model="covered" type="radio" value="Null" class="form-check-input" required>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="dates">District boundary dates</label>
          <small class="helper-text">Enter one or both of the following.</small>
          <div id="dates">
            <label for="startDate" class="normal-weight">Start date</label>
            <input id="startDate" type="text" class="form-control" placeholder="YYYY-MM-DD" v-model="startDate" />
            <label for="endDate" class="normal-weight">End date</label>
            <input id="endDate" type="text" class="form-control" placeholder="YYYY-MM-DD or null" v-model="endDate" />
          </div>
        </div>
        <div class="form-group">
          <label for="geoIDPrefix">GeoID Prefix</label>
          <input id="geoIDPrefix" type="text" class="form-control" placeholder="970, 960, 950, etc" v-model="geoIDPrefix" />
        </div>
      </form>
    </div>
    <div class="form-group">     
      <button class="btn btn-default submit-btn button" @click="submit">
        Submit
      </button>
      <button class="btn btn-default submit-btn button" @click="reset">
        Reset
      </button>
    </div>
  </div>
</template>
<script>
import Modal from "./shared/Modal";

export default {
  name: "SimplifyDistrictBoundaries",
  components: {
    Modal,
  },
  data() {
    return {
      districtType: null,
      districtState: null,
      covered: undefined,
      startDate: undefined,
      endDate: undefined,
      geoIDPrefix: null,
      loading: false,
      visible: false,
      resultMessage: ""
    };
  },
  methods: {
    reset() {
      this.districtType = null;
      this.districtState = null;
      this.resultMessage = "";
    },
    async submit() {
      this.loading = true;
      if (!this.districtType || !this.districtState || this.covered === undefined || (this.startDate === undefined && this.endDate === undefined)) {
        this.resultMessage = "District type; district state; covered; and start date OR end date are required.";
        this.visible = true;
        this.loading = false;
        return;
      }

      const headers = {"Content-Type": "application/json", "Accept": "application/json"};
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/districts/boundary/simplify`;

      const body = {
        type: this.districtType,
        state: this.districtState.toUpperCase()
      };
      if (this.covered !== undefined && this.covered !== 'Null') {
        body.covered = Boolean(this.covered);
      }
      if (this.startDate !== undefined) {
        body.start_date = this.startDate;
      }
      if (this.endDate !== undefined) {
        if (this.endDate.toLowerCase() === 'null') {
          body.end_date = null;
        } else {
          body.end_date = this.endDate;
        }
      }
      if (this.geoIDPrefix) {
        body.geo_id_prefix = this.geoIDPrefix; 
      }

      let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
        method: "PATCH",
        headers: headers,
        credentials: "include",
        body: JSON.stringify(body)
      });

      this.loading = false;
      response = await response.json();

      if (response.status === 403) {
        alert(response.message);
        window.location.href = "/login";
      } else {
        this.resultMessage = response.message;
        this.visible = true;
      }
    }
  }
};
</script>
<style scoped>
  .button {
    width: 100px;
  }
  .helper-text {
    display: block;
  }
  .normal-weight {
    font-weight: normal;
  }
</style>
